import { Link } from "react-router-dom";
import "../../styles/v2/layouts/auth.css";

function TwoColumnAuth({ children }) {
  return (
    <div className="two-column-auth">
      <div className="auth-left-column">
        <Link to="/">
          <img 
            src={`${process.env.PUBLIC_URL}/images/logo_white.svg`} 
            alt="Plaintr Logo" 
            className="auth-logo"
          />
        </Link>
        <img 
          src={`${process.env.PUBLIC_URL}/images/social_graph.svg`} 
          alt="Authentication illustration" 
          className="auth-illustration"
        />
      </div>
      <div className="auth-right-column">
        {children}
      </div>
    </div>
  );
}

export default TwoColumnAuth;
